import { createEntityAdapter } from '@reduxjs/toolkit';
import { IDuctAdapter } from 'application/components/api/DuctAdapter';

export const ductAdapterAdapter = createEntityAdapter<IDuctAdapter, number>({
  selectId: (project) => project.ductAdapterID,
});
